module.exports = __webpack_public_path__ + "static/media/illustration-kerrisdale-stripped.f64ae13b.png";